var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var Youtube = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M19.5 6a2.3 2.3 0 0 0-1.77-1.6C16.23 4 9.97 4 9.97 4s-6.26 0-7.8.4C1.32 4.6.66 5.2.43 6 0 7.4 0 10.35 0 10.35s0 2.95.44 4.4c.22.8.89 1.4 1.78 1.6 1.5.4 7.75.4 7.75.4s6.26 0 7.81-.4c.83-.2 1.56-.85 1.78-1.6.44-1.4.44-4.4.44-4.4S19.94 7.4 19.5 6ZM7.92 13.05V7.7l5.21 2.7-5.2 2.65Z" }))); });
//# sourceMappingURL=Youtube.js.map